export default class Ukey {
    constructor() {
        const userInfo = JSON.parse(localStorage.getItem('user_info'))
        this.ukeyId = ''
        this.ukeyCode = ''
        this.ukeyList = userInfo.tax3UkeyList
        this.payee = ''
        this.checker = ''
        this.openPeople = userInfo.user.realName
        this.deviceType = ''
        this.quotas = {
            0: '',
            2: '',
            51: '',
            41: '',
            52: '',
        }
    }

    formInvoice(invoice) {
        this.ukeyId = invoice.ukeyId
        this.ukeyCode = invoice.ukeyCode
        this.diskCode = invoice.diskCode
        this.diskId = invoice.diskId
        this.payee = invoice.payee
        this.checker = invoice.checker
        this.openPeople = invoice.openPeople
        this.deviceType = invoice.deviceType
        return this
    }

    fromUkey(ukey) {
        if (ukey) {
            this.ukeyId = ukey.ukeyId
            this.ukeyCode = ukey.ukeyCode
            this.diskCode = ukey.diskCode
            this.diskId = ukey.diskId
            this.payee = ukey.defaultPayee
            this.checker = ukey.defaultReviewer
            this.deviceType = ukey.deviceType
        }
        // this.openPeople = ukey.defaultDrawer
        return this
    }
}



// WEBPACK FOOTER //
// ./src/app/outputManage/fillOpenManage/invoice1/standModel/Ukey.js